import './basic-details.css';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Spin } from 'antd';
import TextInput from '../../../../components/TextInput/index';
import SelectionInput from '../../../../components/SelectionInput/index';
import BooleanInput from '../../../../components/BooleanInput/index';
import CheckboxInput from '../../../../components/CheckboxInput/index';
import CustomAccordion from '../../../../components/custom-accordion/custom-accordion';
import QuizFormButtons from '../../../../components/quiz-form-buttons/quiz-form-buttons';
import { useQuizFormContext } from '../../../../hooks/quiz-form-context';
import RegisterWarnContainer from '../../../../components/register-warn-container/register-warn-container';
import { useParams } from 'react-router-dom';


const BasicDetails = ({ inputFields, nextPage, backPage, pageType }) => {
  const { formValues, setFormValues, allFormErrorsList, setAllFormErrorsList, contentFullErrorMsg, isLoggin, setIsLoggin, setIsFormValuesSaved } = useQuizFormContext();
  let stepOneAllQuestionsId = [];
  let { handbookId } = useParams();
  const [isStoragePresent, setIsStoragePresent] = useState(false)
  const setLocalStorage = (handbook) => {
    const isReset = JSON.parse(localStorage.getItem('reset'));
    if (!isReset) {
      localStorage.setItem("quiz-step1-page1", JSON.stringify(handbook.basicDetails))
      localStorage.setItem("quiz-step2-page1", JSON.stringify(handbook.additionalDetails))
      setIsStoragePresent(true)
    }
  }
  //API INTEGRATION HANDBOOK BY ID
  function FetchFormValues(handbookId) {
    if (handbookId) {
      try {
        const endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/${handbookId}`;
        const token = JSON.parse(localStorage.getItem('loginToken'));


        // Make the HTTP GET request
        fetch(endpoint, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data?.jsonBody?.handbook) {
              const handbook = data?.jsonBody?.handbook;
              setLocalStorage(handbook)
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } catch { }
    }
  }

  //RETURN VALUE OBJECT BY INPUTNAME FROM FORMVALUES OBJECT
  function getInputFieldValues(inputName) {
    const inputObject = formValues.find((item) => {
      const key = Object.keys(item)[0];
      return key === inputName;
    });

    return inputObject ? inputObject[Object.keys(inputObject)[0]] : {};
  }

  useEffect(() => {
    const checkLogin = JSON.parse(localStorage.getItem('loginToken'));
    if (checkLogin) {
      let formValuesstep1;
      let formValuesstep2;
      const formValuesStep1Backup = localStorage.getItem('quiz-step1-page1-backup');
      const formValuesStep2Backup = localStorage.getItem('quiz-step2-page1-backup');
      if (formValuesStep1Backup || formValuesStep2Backup) {
        if (formValuesStep1Backup) {
          localStorage.setItem("quiz-step1-page1", formValuesStep1Backup);
          formValuesstep1 = JSON.parse(formValuesStep1Backup);
          localStorage.removeItem("quiz-step1-page1-backup");
        }
        if (formValuesStep2Backup) {
          localStorage.setItem("quiz-step2-page1", formValuesStep2Backup);
          localStorage.setItem("selected-workplace-hazard", localStorage.getItem('selected-workplace-hazard-backup'));
          formValuesstep2 = JSON.parse(formValuesStep2Backup);
          localStorage.removeItem("quiz-step2-page1-backup");
          localStorage.removeItem("selected-workplace-hazard-backup");
        }
      } else {
        formValuesstep1 = JSON.parse(localStorage.getItem('quiz-step1-page1'));
        formValuesstep2 = JSON.parse(localStorage.getItem('quiz-step2-page1'));
      }

      if (formValuesstep2) {
        setFormValues(formValuesstep2)
      } else if (formValuesstep1) {
        setFormValues(formValuesstep1.formValues)
      } else if (handbookId) {
        FetchFormValues(handbookId);
      } else {
        setFormValues([])
      }
      setIsLoggin(true)
    } else {
      const parsedStoreValues = JSON.parse(localStorage.getItem('quiz-step1-page1'));
      const parsedStoreValuesStep2 = JSON.parse(localStorage.getItem('quiz-step2-page1'));
      if (parsedStoreValuesStep2) {
        setFormValues(parsedStoreValuesStep2);
      } else if (parsedStoreValues?.formValues) {
        setFormValues(parsedStoreValues.formValues);
      } else {
        setFormValues([]);
      }
    }
  }, [isStoragePresent]);

  //LOGIC TO HIDE SHOW COMPONENT AS PER REQUIREMENT[ conditon true means show COMPONENT else dont show]
  function checkInputRequirements(requirements) {
    for (const field of requirements.questionRequirements || []) {
      if (field.fields) {
        let formFieldObj = {};
        switch (field?.fields?.question?.fields?.id) {
          case '2': {
            formFieldObj = getInputFieldValues('2');
            return field?.fields?.answerTest?.or?.includes(formFieldObj?.value);
          }
          case '3': {
            formFieldObj = getInputFieldValues('3');
            let formFieldExceptionObj = getInputFieldValues('2');
            return field?.fields?.answerTest?.or?.includes(String(formFieldObj?.value)) && (formFieldExceptionObj?.value == '20-49' || formFieldExceptionObj?.value == '50+');
          }
          case '5': {
            formFieldObj = getInputFieldValues('5');
            return field?.fields?.answerTest?.or?.includes(String(formFieldObj?.value));
          }
          case '8': {
            formFieldObj = getInputFieldValues('8');
            return formFieldObj?.value?.some(
              (sector) =>
                sector?.value === String(Object.keys(field?.fields?.answerTest)[0]),
            );
          }
          default: {
            return true;
          }
        }
      }
    }

    return false;
  }
  //TO DISPLAY Input FIELDS AS PER questionType
  function renderInputFieldsHandler(inputFields, index) {
    const { fields: inputValues } = inputFields;
    stepOneAllQuestionsId = [...stepOneAllQuestionsId, inputValues?.id]
    if (inputValues?.questionRequirements) {
      const isValid = checkInputRequirements(inputValues);
      if (isValid === undefined || !isValid) {
        return;
      }
    }

    // If user is not logged in then don't show company logo question
    if (inputValues.title === 'Company Logo' && !localStorage.getItem('loginToken')) {
      return;
    }


    switch (inputValues?.questionType || inputFields?.sys?.contentType?.sys?.id) {
      case 'String': {
        return (
          <TextInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            size="large"
            allInputOnchageHandler={allInputOnchageHandler}
            anwerRequirements={inputValues?.anwerRequirements}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Boolean': {
        return (
          <BooleanInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            questionValueOptions={inputValues.questionValueOptions}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Selection': {
        return (
          <SelectionInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            questionValueOptions={inputValues.questionValueOptions}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Checkbox': {
        return (
          <CheckboxInput
            title={inputValues.title}
            description={inputValues?.description}
            Error={inputValues?.error}
            name={inputValues.id}
            questionValueOptions={inputValues?.questionValueOptions}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'pdfDocumentText': {
        return (
          <CustomAccordion
            name={inputValues?.name}
            description={inputValues?.ParaText}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          ></CustomAccordion>
        );
      }

      default: {
        return <></>;
      }
    }
  }

  //ALL INPUT ONCHANGE HANDLER
  const allInputOnchageHandler = (
    indexKey,
    title,
    name,
    val,
    sysid,
    outcomeId,
    override,
  ) => {
    setIsFormValuesSaved(false)
    if (Object.keys(allFormErrorsList).length > 0) {
      if ((val !== '' || val.length > 0) && allFormErrorsList[name]) {
        const tempErrsObj = allFormErrorsList;
        delete tempErrsObj[name];
        setAllFormErrorsList(tempErrsObj);
      }
    }
    setFormValues((prev) => {
      const updatedValues = [...prev];
      const existingIndex = updatedValues.findIndex((item) => item?.hasOwnProperty(name));

      if (existingIndex === -1) {
        // If the key doesn't exist, add a new entry
        updatedValues.push({
          [`${name}`]: {
            id: sysid,
            questionName: title,
            value: val,
            outcome: outcomeId,
            override: override,
          },
        });
      } else {
        // If the key already exists, replace the existing entry
        updatedValues[existingIndex] = {
          [`${name}`]: {
            id: sysid || prev[existingIndex][name]?.id,
            questionName: title,
            value: val,
            outcome: outcomeId,
            override: override,
          },
        };
      }
      return updatedValues;
    });
  };
  function updateValues(arrayA, arrayB) {
    for (let objA of arrayA) {
      for (let keyA in objA) {
        for (let objB of arrayB) {
          if (objB.hasOwnProperty(keyA)) {
            objB[keyA] = objA[keyA];
          }
        }
      }
    }
  }

  //SET APPLICABLE COMITTEE BY CHECKING ALL CONDITION on FORMVALUES
  async function decideApplicableCommittee(sortFormValues, registerToSave = false) {
    let noOfEmployeeObj = getInputFieldValues('2');
    let finalOutcome = null;
    let overrideOutcome = null;
    let tempOutcome = null;
    if (sortFormValues?.length > 0) {
      await sortFormValues?.forEach((valObj) => {
        const key = Object.keys(valObj)[0];
        if (key == '4' && noOfEmployeeObj?.value === "20-49") {
          if (valObj[key]?.value === true) {
            //JHSC(A) accordion Id 
            tempOutcome = { outcome: process.env.REACT_APP_JHSC_A_ID, questionName: valObj[key]?.questionName, name: key }
          }
          //Health & Seafty representative accordion Id
          if (valObj[key]?.value === false) {
            tempOutcome = { outcome: process.env.REACT_APP_HSR_ID, questionName: valObj[key]?.questionName, name: key }
          }
        } else {
          tempOutcome = { outcome: valObj[key]?.outcome, questionName: valObj[key]?.questionName, name: key }
        }
        const override = valObj[key]?.override;

        if (tempOutcome?.outcome) {
          if (override === true) {
            overrideOutcome = tempOutcome;
          } else {
            finalOutcome = tempOutcome;
          }
        }
      });
      const tempFormValues = {
        formValues,
        outcome: overrideOutcome ? overrideOutcome : finalOutcome
      };
      let setItemStep1Str = 'quiz-step1-page1';
      let setItemStep2Str = 'quiz-step2-page1';
      if (registerToSave) {
        setItemStep1Str = 'quiz-step1-page1-backup';
        setItemStep2Str = 'quiz-step2-page1-backup';
      }
      localStorage.setItem(setItemStep1Str, JSON.stringify(tempFormValues));
      const step2Data = JSON.parse(localStorage.getItem(setItemStep2Str))
      if (step2Data) {
        updateValues(tempFormValues.formValues, step2Data);
        localStorage.setItem(setItemStep2Str, JSON.stringify(step2Data));
      }
    }
  }

  function findIndexFromFormValue(key, formValues) {
    const indexToRemove = formValues?.findIndex((obj) => key in obj);
    return indexToRemove;
  }

  //To RESET ALL HIDDEN INPUTS VALUES{Doing this beacause 1st user YES selected and after if User selected No then have to Delete its sub dependent hidden Input value }
  function resetAllHiddenInputValue() {
    // Logic omitted for brevity
    let conditionalFieldsIds = ['2', '3', '8'];

    const fieldConfig = [
      { fieldId: '2', fieldToCheck: '3' },
      { fieldId: '3', fieldToCheck: '4' },
      // Add more configurations as needed
    ];

    const removeFieldsMap = {
      'Service': '9',
      'Manufacturing': '10',
      'Agriculture': '11'
    };

    //To remove checkbox values
    const removeFieldsByFieldId = (valuesToCheck, formValues) => {
      valuesToCheck.forEach(val => {
        const fieldIdToRemove = removeFieldsMap[val];
        if (fieldIdToRemove) {
          let indexToRemove = findIndexFromFormValue(fieldIdToRemove, formValues);
          if (indexToRemove !== -1) {
            formValues.splice(indexToRemove, 1); // remove the field from formValues
          }
        }
      });
    };

    conditionalFieldsIds.forEach((fieldId) => {
      let fieldValue = getInputFieldValues(fieldId, formValues);

      if (fieldId === '8' && fieldValue) {
        let missingValues = ['Service', 'Manufacturing', 'Agriculture'].filter(item => !fieldValue?.value?.some(obj => obj?.value === item));
        if (missingValues.length > 0) {
          removeFieldsByFieldId(missingValues, formValues);
        }
      }

      const config = fieldConfig.find((config) => config?.fieldId === fieldId);
      if (config && fieldValue && fieldValue?.value === false) {
        let indexToRemove = findIndexFromFormValue(config.fieldToCheck, formValues);
        if (indexToRemove !== -1) {
          formValues?.splice(indexToRemove, 1); // remove the field from FormValues
        }
      }

      if (fieldId === '2') {
        // this condition is to remove those question which are depends on the answer of this fieldId=2
        let valuesToCheck = ['20-49', '50+']
        if (fieldValue && !valuesToCheck?.includes(fieldValue?.value)) {
          let removeSpecificFarmingIndex = findIndexFromFormValue('4', formValues);//first user selected 20+ and then select eg. 6-19 the we need to delete specfic farming
          if (removeSpecificFarmingIndex !== -1) {
            formValues?.splice(removeSpecificFarmingIndex, 1); // remove the field from FormValues
          }
          let indexToRemove = findIndexFromFormValue(config.fieldToCheck, formValues);
          if (indexToRemove !== -1) {
            formValues?.splice(indexToRemove, 1); // remove are you farming opration the field from FormValues
          }
        }
      }
    });
  }


  //SAVE FORMDATA TO LOCAL STORAGE
  function handleNextPageAction() {
    resetAllHiddenInputValue()
    const sortFormValues = formValues?.sort((a, b) => {
      return Number.parseInt(Object.keys(a)[0]) - Number.parseInt(Object.keys(b)[0]);
    });

    const isValid = checkQuizFormValidation();
    if (!isValid) return false;

    decideApplicableCommittee(sortFormValues);
    setAllFormErrorsList({});
    return true;
  }

  //RESET FORMDATA
  function resetFormData() {
    localStorage.setItem("reset", true)
    setFormValues([]);
    localStorage.removeItem('quiz-step1-page1');
    localStorage.removeItem('quiz-step2-page1');
    window.location.reload()
  }

  //GO TO BACK PAGE
  function backPageHandler() {
    setAllFormErrorsList({});
    backPage();
  }

  function registerToSave() {
    localStorage.setItem("registerToSaveSkipToPage1", true);
    const sortFormValues = formValues?.sort((a, b) => {
      return Number.parseInt(Object.keys(a)[0]) - Number.parseInt(Object.keys(b)[0]);
    });
    decideApplicableCommittee(sortFormValues, true);
  }

  // FORM VALIDATION LOGIC
  function checkQuizFormValidation() {
    let errors = {};
    const stepOneContentfulErrors = {};
    stepOneAllQuestionsId?.forEach(key => {
      // Check if the key exists in contentFullErrorMsg
      if (contentFullErrorMsg.hasOwnProperty(key)) {
        stepOneContentfulErrors[key] = contentFullErrorMsg[key];
      }
    });
    for (let key in stepOneContentfulErrors) {
      const fieldValue = getInputFieldValues(key);
      if (Object.keys(fieldValue)?.length <= 0 || fieldValue?.value === '') {
        errors[key] = stepOneContentfulErrors[key] || `${key} is required`;
      }
      if (Object.keys(fieldValue)?.length >= 0 && fieldValue?.value && Array.isArray(fieldValue?.value)) {
        if (fieldValue?.value?.length === 0) {
          errors[key] = stepOneContentfulErrors[key] || `${key} is required`;
        }
      }
    }
    if (Object.keys(errors)?.length > 0) {
      setAllFormErrorsList(errors);
      return false;
    } else {
      return true;
    }
  }

  const nextPageClickHandle = () => {
    nextPage()
  }
  const checkLoaderCondition = () => {
    if (formValues.length === 0 && handbookId && !JSON.parse(localStorage.getItem('reset'))) return true
    else return false
  }
  return (
    <div className="quiz-form-main-container">
      {pageType === 'BasicDetails' && (
        <>
          {checkLoaderCondition() ? (<Spin />) : (<>
            <div className="heading-container">
              <div className='basic-details-text'>Basic Details</div>
              <h1>Tell us about your workplace</h1>
              <span>*Required field</span>
            </div>
            {
              !isLoggin && <RegisterWarnContainer registerToSave={() => registerToSave()} />
            }
            {Object.keys(allFormErrorsList).length > 0 && (
              <div className="error-list-container">
                <div className="warn-message-container">
                  <img className="worn-icon" src="./images/error-icon.png" alt="warn-icon" />
                  <span style={{ color: '#FF564A' }}>Errors were detected in the following fields:</span>
                </div>
                <ul className="error-list">
                  {Object.keys(allFormErrorsList).map((errorKey) => {
                    return (
                      <li className="error-item" key={errorKey}>
                        {allFormErrorsList[errorKey]}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className="form-wrapper-container">
              <Form
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                layout="vertical"
                className="form-container"
              >
                <div className="section-container">
                  <Row className="field-container">
                    {inputFields.fields?.questionType?.map((field, index) => (
                      <Col key={field.sys.id} span={24}>
                        <div className={field?.fields?.questionRequirements ? "requirement-border" : ""}>
                          {renderInputFieldsHandler(field, index)}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Form>
              <QuizFormButtons
                pageType="BasicDetails"
                nextPageClick={() => nextPageClickHandle()}
                backPageClick={() => backPageHandler()}
                registerToSave={() => registerToSave()}
                handleNextPageAction={handleNextPageAction}
                resetFormData={resetFormData}
                isLoggin={isLoggin}
              />
            </div>
          </>)

          }
        </>
      )}
    </div>
  );
};

export default BasicDetails;
